import React from 'react';
import { Star, Award, Heart } from 'lucide-react';
import { propertyInfo } from '../mock';

export const About = () => {
  return (
    <section id="about" className="py-12 sm:py-16 md:py-20 lg:py-28 bg-[#FBFAF7]">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Trust Block - Mobile Optimized */}
        <div className="max-w-4xl mx-auto text-center mb-10 sm:mb-12 md:mb-16">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 bg-white px-5 sm:px-8 py-5 rounded-lg shadow-sm border border-[rgba(7,25,54,0.10)]">
            <div className="flex items-center gap-2">
              <Star className="text-[#2AA7A1] fill-[#2AA7A1]" size={18} />
              <span className="font-medium text-[#071936] text-sm sm:text-base">4.98 Airbnb Rating</span>
            </div>
            <div className="flex items-center gap-2">
              <Award className="text-[#2AA7A1]" size={18} />
              <span className="font-medium text-[#071936] text-sm sm:text-base">Superhost</span>
            </div>
            <div className="flex items-center gap-2">
              <Heart className="text-[#2AA7A1] fill-[#2AA7A1]" size={16} />
              <span className="text-[#6B7280] text-sm sm:text-base">Over 150 reviews</span>
            </div>
          </div>
          <p className="text-[#6B7280] mt-3 sm:mt-4 text-xs sm:text-sm px-4">
            Loved by couples looking for a peaceful coastal escape
          </p>
        </div>

        {/* Main Content - Mobile Stack */}
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center max-w-7xl mx-auto">
          {/* Images - Mobile Optimized */}
          <div className="space-y-3 sm:space-y-4">
            <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-1">
              <img
                src="https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/tg4hlv3b_Inside.jpeg"
                alt="Interior of The Tullaghan Pod - cosy double bed and living space"
                className="w-full h-64 sm:h-80 md:h-[400px] object-cover transition-transform duration-700 hover:scale-105"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="grid grid-cols-2 gap-3 sm:gap-4">
              <div className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-1">
                <img
                  src="https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/vax28qy1_Hot%20tub.jpeg"
                  alt="Wood-fired hot tub with ocean views"
                  className="w-full h-36 sm:h-44 md:h-48 object-cover transition-transform duration-700 hover:scale-105"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-1">
                <img
                  src="https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/xs2q3wbf_Kitchen.jpeg"
                  alt="Kitchenette with cooker, fridge, and dining area"
                  className="w-full h-36 sm:h-44 md:h-48 object-cover object-center transition-transform duration-700 hover:scale-105"
                  style={{ objectPosition: '50% 45%' }}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          </div>

          {/* Story - Mobile Typography */}
          <div className="space-y-5 sm:space-y-6">
            <div>
              <h2 className="text-3xl sm:text-4xl lg:text-4xl font-light text-[#071936] leading-tight mb-4 sm:mb-6">
                {propertyInfo.tagline}
              </h2>
              
              <p className="text-base sm:text-lg text-[#1F2937] mb-4 sm:mb-6" style={{ lineHeight: '1.7' }}>
                {propertyInfo.description}
              </p>
            </div>

            {/* Meet Hosts - Mobile Compact */}
            <div className="pt-5 sm:pt-6 border-t border-[rgba(7,25,54,0.10)]">
              <p className="text-xs sm:text-sm uppercase tracking-wider text-[#6B7280] mb-3">Your Hosts</p>
              <p className="text-[#071936] font-medium text-base sm:text-lg mb-2">Caroline & Joe</p>
              <p className="text-sm sm:text-base text-[#6B7280]" style={{ lineHeight: '1.7' }}>
                {propertyInfo.hostStory}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
